(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-grid-columns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    applyResponsiveTypography();
    applyResponsivePadding();
  });
  
  window.addEventListener('resize', function() {
    applyResponsiveTypography();
    applyResponsivePadding();
  });
  
  document.addEventListener('shopify:section:load', function() {
    applyResponsiveTypography();
    applyResponsivePadding();
  });
  
  function applyResponsiveTypography() {
    // Apply responsive font sizes for titles
    const titles = document.querySelectorAll('.bd-grid-columns__title');
    titles.forEach(title => {
      const desktopSize = title.dataset.desktopSize;
      const mobileSize = title.dataset.mobileSize;
      
      if (window.innerWidth <= 768) {
        title.style.fontSize = `${mobileSize}px`;
      } else {
        title.style.fontSize = `${desktopSize}px`;
      }
    });
    
    // Apply responsive font sizes for subtitles
    const subtitles = document.querySelectorAll('.bd-grid-columns__subtitle');
    subtitles.forEach(subtitle => {
      const desktopSize = subtitle.dataset.desktopSize;
      const mobileSize = subtitle.dataset.mobileSize;
      
      if (window.innerWidth <= 768) {
        subtitle.style.fontSize = `${mobileSize}px`;
      } else {
        subtitle.style.fontSize = `${desktopSize}px`;
      }
    });
  }
  
  function applyResponsivePadding() {
    const sections = document.querySelectorAll('.bd-grid-columns');
    sections.forEach(section => {
      const desktopPaddingTop = section.dataset.desktopPaddingTop;
      const mobilePaddingTop = section.dataset.mobilePaddingTop;
      const desktopPaddingBottom = section.dataset.desktopPaddingBottom;
      const mobilePaddingBottom = section.dataset.mobilePaddingBottom;
      
      if (window.innerWidth <= 768) {
        section.style.paddingTop = `${mobilePaddingTop}px`;
        section.style.paddingBottom = `${mobilePaddingBottom}px`;
      } else {
        section.style.paddingTop = `${desktopPaddingTop}px`;
        section.style.paddingBottom = `${desktopPaddingBottom}px`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-image-color-carousel"] && !Shopify.designMode) return;
  try {
    
  class BDImageColorCarousel {
    constructor(container) {
      this.container = container;
      this.desktopImages = container.querySelectorAll(
        '.bd-image-color-carousel__image-column .bd-image-color-carousel__image-item'
      );
      this.mobileImages = container.querySelectorAll(
        '.bd-image-color-carousel__mobile-images .bd-image-color-carousel__image-item'
      );
      this.colorSwatches = container.querySelectorAll('.bd-image-color-carousel__color-swatch');
      this.currentIndex = 0;
      this.autoPlay = container.querySelector('[data-carousel]').dataset.autoPlay === 'true';
      this.timer = parseInt(container.querySelector('[data-carousel]').dataset.timer) || 2000;
      this.intervalId = null;

      this.init();
    }

    init() {
      this.bindEvents();
      if (this.autoPlay) {
        this.startAutoPlay();
      }
    }

    bindEvents() {
      // Color swatch click events
      this.colorSwatches.forEach((swatch, index) => {
        swatch.addEventListener('click', () => {
          this.goToSlide(index);
          this.pauseAutoPlay();
        });
      });

      // Pause on hover
      this.container.addEventListener('mouseenter', () => {
        this.pauseAutoPlay();
      });

      // Resume on mouse leave
      this.container.addEventListener('mouseleave', () => {
        if (this.autoPlay) {
          this.startAutoPlay();
        }
      });
    }

    goToSlide(index) {
      // Handle desktop images
      if (this.desktopImages.length > 0) {
        if (index < 0 || index >= this.desktopImages.length) return;

        // Remove active class from current desktop image
        if (this.desktopImages[this.currentIndex]) {
          this.desktopImages[this.currentIndex].classList.remove('active');
        }

        // Add active class to new desktop image
        if (this.desktopImages[index]) {
          this.desktopImages[index].classList.add('active');
        }
      }

      // Handle mobile images
      if (this.mobileImages.length > 0) {
        if (index < 0 || index >= this.mobileImages.length) return;

        // Remove active class from current mobile image
        if (this.mobileImages[this.currentIndex]) {
          this.mobileImages[this.currentIndex].classList.remove('active');
        }

        // Add active class to new mobile image
        if (this.mobileImages[index]) {
          this.mobileImages[index].classList.add('active');
        }
      }

      // Handle color swatches
      if (this.colorSwatches[this.currentIndex]) {
        this.colorSwatches[this.currentIndex].classList.remove('active');
      }

      // Update current index
      this.currentIndex = index;

      // Add active class to new color swatch
      if (this.colorSwatches[this.currentIndex]) {
        this.colorSwatches[this.currentIndex].classList.add('active');
      }
    }

    nextSlide() {
      const totalImages = Math.max(this.desktopImages.length, this.mobileImages.length);
      const nextIndex = (this.currentIndex + 1) % totalImages;
      this.goToSlide(nextIndex);
    }

    startAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.timer);
    }

    pauseAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }

  // Initialize carousel when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-section-type="bd-image-color-carousel"]');
    carousels.forEach((carousel) => {
      new BDImageColorCarousel(carousel);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-image-text-section"] && !Shopify.designMode) return;
  try {
    
  class BDImageTextSection {
    constructor(element) {
      this.element = element;
      this.scrollContainer = element.querySelector('.bd-image-text-section__scroll-container');
      if (this.scrollContainer) {
        this.setupScrolling();
        this.setupVisibility();
        this.setupResize();
      }
    }

    setupScrolling() {
      let items = Array.from(this.scrollContainer.querySelectorAll('[data-original]'));
      if (!items.length) {
        items = Array.from(this.scrollContainer.children);
        items.forEach(item => item.setAttribute('data-original', 'true'));
      }
      if (!items.length) return;

      const gap = window.innerWidth <= 768 ? 60 : 100;
      let width = 0;
      
      items.forEach(item => {
        const styles = window.getComputedStyle(item);
        width += item.offsetWidth + parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
      });
      
      width += gap * (items.length - 1);
      const duplications = Math.ceil(window.innerWidth * 2.5 / width) + 1;

      this.scrollContainer.querySelectorAll('[data-clone]').forEach(c => c.remove());
      
      for (let i = 0; i < duplications; i++) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-clone', 'true');
          clone.removeAttribute('data-original');
          this.scrollContainer.appendChild(clone);
        });
      }

      this.scrollContainer.style.setProperty('--animation-distance', `-${width}px`);
    }

    setupVisibility() {
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.scrollContainer.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      }).observe(this.element);
    }

    setupResize() {
      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.setupScrolling(), 250);
      });
    }
  }

  // Apply mobile background styles
  function applyMobileBackground() {
    const sections = document.querySelectorAll('.bd-image-text-section');
    sections.forEach(section => {
      const mobileImage = section.dataset.mobileBgImage;
      const mobileColor = section.dataset.mobileBgColor;
      const desktopImage = section.style.backgroundImage;
      const desktopColor = section.style.backgroundColor;
      
      if (window.innerWidth <= 768) {
        // Use mobile image if available, otherwise keep desktop image
        if (mobileImage && mobileImage.trim() !== '') {
          section.style.backgroundImage = `url('${mobileImage}')`;
        }
        // Use mobile color if available, otherwise keep desktop color
        if (mobileColor && mobileColor.trim() !== '') {
          section.style.backgroundColor = mobileColor;
        }
      } else {
        // Reset to original inline styles for larger screens
        const originalBgImage = section.getAttribute('data-original-bg-image') || '';
        const originalBgColor = section.getAttribute('data-original-bg-color') || '';
        
        if (originalBgImage) {
          section.style.backgroundImage = originalBgImage;
        } else {
          section.style.backgroundImage = '';
        }
        
        if (originalBgColor) {
          section.style.backgroundColor = originalBgColor;
        } else {
          section.style.backgroundColor = '';
        }
      }
    });
  }

  // Apply responsive text sizes
  function applyResponsiveTextSizes() {
      const textElements = document.querySelectorAll('.bd-image-text-section__text');
      textElements.forEach(textElement => {
        const desktopSize = textElement.dataset.desktopTextSize;
        const mobileSize = textElement.dataset.mobileTextSize;
        const paragraphs = textElement.querySelectorAll('p');
        
        paragraphs.forEach(p => {
          if (window.innerWidth <= 768) {
            p.style.fontSize = `${mobileSize}px`;
          } else {
            p.style.fontSize = `${desktopSize}px`;
          }
        });
      });
    }

  // Store original background values
  function storeOriginalBackgrounds() {
    const sections = document.querySelectorAll('.bd-image-text-section');
    sections.forEach(section => {
      const computedStyle = window.getComputedStyle(section);
      section.setAttribute('data-original-bg-image', computedStyle.backgroundImage);
      section.setAttribute('data-original-bg-color', computedStyle.backgroundColor);
    });
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.bd-image-text-section');
    sections.forEach(section => {
      new BDImageTextSection(section);
    });
    
    storeOriginalBackgrounds();
    applyMobileBackground();
    applyResponsiveTextSizes();
    window.addEventListener('resize', () => {
      applyMobileBackground();
      applyResponsiveTextSizes();
    });
  });

  // Handle theme editor updates
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.bd-image-text-section');
    if (section) {
      new BDImageTextSection(section);
      storeOriginalBackgrounds();
      applyMobileBackground();
      applyResponsiveTextSizes();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-single-column-accordion"] && !Shopify.designMode) return;
  try {
    
  function applyResponsivePadding() {
    const sections = document.querySelectorAll('.bd-single-column-accordion');
    sections.forEach(section => {
      const desktopPaddingTop = section.getAttribute('data-desktop-padding-top');
      const desktopPaddingBottom = section.getAttribute('data-desktop-padding-bottom');
      const mobilePaddingTop = section.getAttribute('data-mobile-padding-top');
      const mobilePaddingBottom = section.getAttribute('data-mobile-padding-bottom');
      
      if (window.innerWidth > 768) {
        section.style.padding = `${desktopPaddingTop}px 0 ${desktopPaddingBottom}px`;
      } else {
        section.style.padding = `${mobilePaddingTop}px 0 ${mobilePaddingBottom}px`;
      }
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    applyResponsivePadding();
    initializeSingleColumnAccordion();
  });
  
  document.addEventListener('shopify:section:load', function() {
    applyResponsivePadding();
    initializeSingleColumnAccordion();
  });
  
  window.addEventListener('resize', applyResponsivePadding);
  
  function initializeSingleColumnAccordion() {
    const accordionToggles = document.querySelectorAll('.bd-single-column-accordion [data-accordion-toggle]');
    
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const accordionItem = this.closest('[data-accordion-item]');
        const content = accordionItem.querySelector('.bd-single-column-accordion__accordion-content');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other accordion items in the same section
        const allItems = accordionItem.closest('.bd-single-column-accordion__accordion').querySelectorAll('[data-accordion-item]');
        allItems.forEach(item => {
          if (item !== accordionItem) {
            const otherToggle = item.querySelector('[data-accordion-toggle]');
            const otherContent = item.querySelector('.bd-single-column-accordion__accordion-content');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherContent.removeAttribute('data-accordion-open');
          }
        });
        
        // Toggle current item
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          content.removeAttribute('data-accordion-open');
        } else {
          this.setAttribute('aria-expanded', 'true');
          content.setAttribute('data-accordion-open', '');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-text-carousel"] && !Shopify.designMode) return;
  try {
    
  class BDTextCarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-carousel-track]');
      this.wrapper = element.querySelector('.bd-text-carousel__wrapper'); // NEW
      this.items = element.querySelectorAll('[data-carousel-item]');
      this.progressFill = element.querySelector('[data-progress-fill]');
      this.currentIndex = 0;
      this.intervalTime = parseInt(this.element.dataset.autoplayInterval) || 2000; // default 2 seconds
      this.interval = null;

      // NEW: bind + initial height
      this.setTrackHeight = this.setTrackHeight.bind(this);
      this.setTrackHeight();
      window.addEventListener('resize', this.setTrackHeight);
      window.addEventListener('load', this.setTrackHeight);
      this.element.querySelectorAll('img').forEach((img) => {
        img.addEventListener('load', this.setTrackHeight);
      });

      if (this.items.length > 1) this.init();
    }

    // NEW: meet hoogste item en zet min-height op de track
    setTrackHeight() {
      if (!this.track || !this.items.length) return;
      let maxH = 0;
      this.items.forEach((it) => {
        // scrollHeight werkt ook bij absolute positioned items
        maxH = Math.max(maxH, it.scrollHeight);
      });
      this.track.style.minHeight = `${maxH}px`;
    }

    init() {
      this.updateProgressBar();
      this.startAutoplay();
      this.element.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.element.addEventListener('mouseleave', () => this.startAutoplay());
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.pauseAutoplay() : this.startAutoplay()
      );
      if (this.progressFill?.parentElement) {
        this.progressFill.parentElement.addEventListener('click', (e) => this.handleProgressBarClick(e));
        this.progressFill.parentElement.addEventListener('wheel', (e) => {
          e.preventDefault();
          this.handleProgressBarScroll(e);
        });
      }
    }
    startAutoplay() {
      this.pauseAutoplay();
      this.updateProgressBar();
      this.interval = setInterval(() => {
        this.nextSlide();
        this.setTrackHeight();
      }, this.intervalTime);
    } // height after change
    pauseAutoplay() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
    nextSlide() {
      this.items[this.currentIndex].classList.remove('bd-text-carousel__item--active');
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.items[this.currentIndex].classList.add('bd-text-carousel__item--active');
      this.updateProgressBar();
      this.setTrackHeight(); // NEW
    }
    updateProgressBar() {
      if (!this.progressFill || this.items.length === 0) return;
      const segmentWidth = 100 / this.items.length;
      const startPosition = this.currentIndex * segmentWidth;
      this.progressFill.style.left = `${startPosition}%`;
      this.progressFill.style.width = `${segmentWidth}%`;
    }
    handleProgressBarClick(e) {
      const bar = this.progressFill.parentElement,
        rect = bar.getBoundingClientRect();
      const idx = Math.floor(((e.clientX - rect.left) / rect.width) * this.items.length);
      if (idx !== this.currentIndex) this.goToSlide(Math.max(0, Math.min(idx, this.items.length - 1)));
    }
    handleProgressBarScroll(e) {
      const delta = e.deltaY > 0 ? 1 : -1;
      let idx = this.currentIndex + delta;
      if (idx >= this.items.length) idx = 0;
      else if (idx < 0) idx = this.items.length - 1;
      if (idx !== this.currentIndex) this.goToSlide(idx);
    }
    goToSlide(index) {
      this.items[this.currentIndex].classList.remove('bd-text-carousel__item--active');
      this.currentIndex = index;
      this.items[this.currentIndex].classList.add('bd-text-carousel__item--active');
      this.updateProgressBar();
      this.setTrackHeight(); // NEW
      this.startAutoplay();
    }
    destroy() {
      this.pauseAutoplay();
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.bd-text-carousel').forEach((c) => new BDTextCarousel(c));
  });
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const c = e.target.querySelector('.bd-text-carousel');
      if (c) new BDTextCarousel(c);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-two-column-accordion"] && !Shopify.designMode) return;
  try {
    
  function applyResponsivePadding() {
    const sections = document.querySelectorAll('.bd-two-column-accordion');
    sections.forEach(section => {
      const desktopPaddingTop = section.getAttribute('data-desktop-padding-top');
      const desktopPaddingBottom = section.getAttribute('data-desktop-padding-bottom');
      const mobilePaddingTop = section.getAttribute('data-mobile-padding-top');
      const mobilePaddingBottom = section.getAttribute('data-mobile-padding-bottom');
      
      if (window.innerWidth > 768) {
        section.style.paddingTop = `${desktopPaddingTop}px`;
        section.style.paddingBottom = `${desktopPaddingBottom}px`;
        section.style.paddingLeft = `52px`;
        section.style.paddingRight = `52px`;
      } else {
        section.style.padding = `${mobilePaddingTop}px 0 ${mobilePaddingBottom}px`;
      }
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    applyResponsivePadding();
    initializeAccordion();
  });
  
  document.addEventListener('shopify:section:load', function() {
    applyResponsivePadding();
    initializeAccordion();
  });
  
  window.addEventListener('resize', applyResponsivePadding);
  
  function initializeAccordion() {
    // Set first accordion item as open by default
    const firstAccordionItem = document.querySelector('.bd-two-column-accordion__accordion-item');
    if (firstAccordionItem) {
      const firstContent = firstAccordionItem.querySelector('.bd-two-column-accordion__accordion-content');
      const firstToggle = firstAccordionItem.querySelector('[data-accordion-toggle]');
      if (firstContent && firstToggle) {
        firstToggle.setAttribute('aria-expanded', 'true');
        firstContent.setAttribute('data-accordion-open', '');
      }
    }
    
    const accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
    
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const accordionItem = this.closest('[data-accordion-item]');
        const content = accordionItem.querySelector('.bd-two-column-accordion__accordion-content');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other accordion items in the same section
        const allItems = accordionItem.closest('.bd-two-column-accordion__accordion').querySelectorAll('[data-accordion-item]');
        allItems.forEach(item => {
          if (item !== accordionItem) {
            const otherToggle = item.querySelector('[data-accordion-toggle]');
            const otherContent = item.querySelector('.bd-two-column-accordion__accordion-content');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherContent.removeAttribute('data-accordion-open');
          }
        });
        
        // Toggle current item
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          content.removeAttribute('data-accordion-open');
        } else {
          this.setAttribute('aria-expanded', 'true');
          content.setAttribute('data-accordion-open', '');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
    
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        
        const content = this.nextElementSibling;
        const isActive = this.classList.contains('footer-accordion__header--active');
        
        // Close all accordions in the same container first
        const container = this.closest('.footer-accordion__mobile-only') || this.closest('.footer-accordion__desktop-only');
        const allToggles = container.querySelectorAll('[data-accordion-toggle]');
        const allContents = container.querySelectorAll('.footer-accordion__content');
        
        allToggles.forEach(t => {
          t.classList.remove('footer-accordion__header--active');
          t.setAttribute('aria-expanded', 'false');
        });
        
        allContents.forEach(c => {
          c.classList.remove('footer-accordion__content--active');
          c.setAttribute('aria-hidden', 'true');
        });
        
        // If this accordion wasn't active, open it
        if (!isActive) {
          this.classList.add('footer-accordion__header--active');
          this.setAttribute('aria-expanded', 'true');
          content.classList.add('footer-accordion__content--active');
          content.setAttribute('aria-hidden', 'false');
        }
      });
    });
    
    // Initialize accordion state on load
    const allAccordions = document.querySelectorAll('.footer-accordion__content');
    allAccordions.forEach(content => {
      content.setAttribute('aria-hidden', 'true');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
